<script>
  export let product

  function increment() {
    product.qty++
  }
  function decrement() {
    if (product.qty > 0) {
      product.qty--
    }
  }
</script>

<div class="quantity-input">
  <i
    class="arrow-left decrease-input"
    role="button"
    on:click={decrement}
    on:keydown={decrement}
    tabindex=0
  />
  <input
    class="item-input"
    type="number"
    min="0"
    oninput="this.value = Math.abs(this.value)"
    name="related_products[{product.id}]"
    bind:value={product.qty}
  />
  <i
    class="arrow-right increase-input"
    role="button"
    on:click={increment}
    on:keydown={increment}
    tabindex=0
  />
</div>
